// @flow
export const noop: mixed => mixed = () => {};

export const getRentalAgreementForClient = (client: string) => {
  const clientName = client || 'Owner';
  return `You agree to release ${clientName} from any and all liability relating to delivery or use of the Products made available by ${clientName}. You agree that Awayco is not a party to the rental or any other agreement or relationship between you and ${clientName}, nor is it acting as an agent, broker, insurance or service provider.`;
};

export const capitalise = (word: string) => word.charAt(0).toUpperCase() + word.slice(1);
